var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Category Details page, id: "+_vm._s(_vm.$route.params.id))])])
}
var staticRenderFns = []

export { render, staticRenderFns }